module.exports = "/_next/static/images/7d66b04a38a9a21a88abd8c5cf7ee85f-foundersfund.png";